/**
 * Represents User Role Enum.
 * @returns {number} - Returns the enum value.
 */
export const UserRole = Object.freeze({
    Admin: 1,
    HR: 2,
    User: 3,
    Team: 4,
    Guest: 5,
    EM: 6
});

const userRoleWeight = [UserRole.User, UserRole.Team, UserRole.EM, UserRole.HR, UserRole.Admin, UserRole.Guest];
export const getUserRoleOrderedBasedOnPriority = (userRoleOptions) => {
    return userRoleWeight.map(index => userRoleOptions[index - 1]);
};